'use client';

import { GovernanceCalendar } from 'mode-shared/components/early/GovernanceCalendar';
import { FeaturedProjectSection } from 'mode-shared/components/early/FeaturedProjectSection';
import { SeasonDetailsBanners } from 'mode-shared/components';
import { useEcosystemDapps } from 'mode-shared/hooks/content/hooks';
import { useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { useSuggestions } from 'mode-shared/hooks/content/hooks/useSuggestions';
import { ModeTitleBanner } from 'mode-shared/components';
import { CTASection } from 'mode-shared/components/early/CTASection';

export const Dashboard = () => {
  const router = useRouter();
  const { data: dapps, isLoading: isEcosystemDappsLoading } = useEcosystemDapps();
  const { data } = useSuggestions();

  const featuredProjects = useMemo(() => {
    return dapps?.filter((dapp) => dapp.featured) || [];
  }, [dapps]);

  return (
    <main className="animate-appear">
      <ModeTitleBanner
        title={
          <p>
            Mode <span className="font-normal">Dashboard</span>
          </p>
        }
      >
        <SeasonDetailsBanners />
      </ModeTitleBanner>
      <div className="mx-auto max-w-[1200px] gap-y-20 pt-10 pb-20 bg-neutral-black gap-x-8 flex flex-col px-[15px] xl:px-0">
        <div className="flex flex-col gap-y-8">
          <GovernanceCalendar />
          <CTASection />
        </div>
        <FeaturedProjectSection
          title="Featured projects"
          projects={featuredProjects}
          isLoading={isEcosystemDappsLoading}
        />
      </div>
    </main>
  );
};
